module.exports = function (cb) {
	var endpointUrl = URI('/api/search/sitesearch/displayinner');
	if (window.q && window.q.length) {
		endpointUrl.setQuery('q', window.q);
	}
	
	if (window.page > 1) {
		endpointUrl.setQuery('page', window.page);
	}

	var browserUrl = URI(window.location.toString());

	if (window.page > 1) {
		browserUrl.setQuery('page', window.page);
	} else {
		browserUrl.removeQuery('page');
	}

	history.replaceState({}, '', browserUrl.toString());

	$.ajax({
		url: endpointUrl.toString(),
		success: function (result) {
			if (cb) {
				cb(result);
			}
		},
		error: function (xhr, status, error) {
			return { 'error': error };
		}
	});
};
